export default __webpack_public_path__ + "static/media/Amdocs Omnichannel Customer Engagement Solution Profile.960bddc0.pdf";